import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {TemplateComponent} from "../template/template.component";
import {BaseListComponent} from "../base-list/base-list.component";
import {EFilterType, ITableConfig} from "../../../interface/table.config";
import {CrudService} from "../service/crud.service";
import {ICrudRes} from "../../../interface/http.config";
import {NgIf} from "@angular/common";
import {Router} from "@angular/router";
import {CrudListModel} from "../../../model/crud-list.model";
import {listFromMap, valueFromList} from "../../../helper/list.helper";
import {ECrudFilterType} from "../../../interface/crud.filter-type.enum";

@Component({
  selector: 'app-client-log',
  standalone: true,
  imports: [
    TemplateComponent,
    BaseListComponent,
    NgIf
  ],
  templateUrl: './client-log.component.html',
  styleUrl: './client-log.component.scss'
})
export class ClientLogComponent extends CrudListModel implements OnInit {

  override editLink = '/dashboard/client-log-edit/';
  override addLink = '/dashboard/client-log-create';

  clientList: Record<string, string> = {};
  clientListMap: {value: string, label: string}[] = [];

  constructor(crudService: CrudService,
              protected cdr: ChangeDetectorRef,
              router: Router) {

    super(crudService, router);

    this.crudService.setProvider('client-log');
    this.crudService.orderBy = 'createdAt';

  }

  protected tableConfig: ITableConfig = {
    cells: [
      {
        header: 'Created At',
        field: 'createdAt',
        sortable: true,
        filterType: EFilterType.DATE,
        value: (item) => (new Date(item.createdAt || Date.now())).toLocaleString(),
        crudFilterType: ECrudFilterType.DATE,
      },
      {
        header: 'Client',
        field: 'clientId',
        sortable: true,
        filterType: EFilterType.SELECT,
        value: valueFromList(this, 'clientList', 'clientId'),
        crudFilterType: ECrudFilterType.EXACT,
        options: () => this.clientListMap,
      },
      {
        header: 'Action',
        field: 'action',
        sortable: true,
        filterType: EFilterType.TEXT,
      },
      {
        header: 'Details',
        field: 'details',
        sortable: false,
        filterType: EFilterType.TEXT,
      },
    ],
    actions: [
      'edit',
      'delete',
    ]
  };

  ngOnInit() {
    this.update();

    this.crudService.getList('client', 'id', 'email').then(data => {
      this.clientList = data;
      this.clientListMap = listFromMap(data);

      this.cdr.detectChanges();
    });
  }
}
